module.exports = __webpack_public_path__ + "media/images/steps/step_6-44300fcc96843d403586b34d62c90588.svg";